<template>
    <div :class="['align-c year-label flex-center', classes.priorityType]">

        <!-- Viewing-year marker -->
        <span class="viewing-year-marker" v-if="ViewingYear(year.year)">
            <img src="@/assets/Images/Dot.png" :alt="`${year.year} - Marker`" :title="`${year.year} - Marker`" width="15" height="15"/>
        </span>

        <div :class="['btn button-information flex-center', Classes().informationButtonState]" @click="ShowInformation()">
            <img class="icon-information" src="@/assets/Images/Ellipses.png" alt="Icon - Ellipses" title="Ellipses" width="35" height="8"/>
        </div>
        <span class="label">{{ year.year }}</span>
        <div class="bottom-trim"></div>
    </div>
    <Popup
        :popup="popup"
        @close="ClosePopup()"
        @view-project="ViewProject($event)"
    />
</template>

<script>
import Popup from "@/components/Popups/Popup.vue";
import PriorityTypes from "@/assets/JS/Data/Navigation.json";
import { ASSETS } from "@/assets/JS/Assets.js";
import router from "@/router";
import store from "@/store";

export default {
    name: "TimelineYear",
    props: {
        year: Object,
        priority: Object,
        showIconInformation: Boolean,
        maxTopography: Number,
        timelineData: Array,
        index: Number,
        enabled: Boolean,
        selectedYearRange: Object
    },
    components: { Popup },
    data: () => ({
        classes: { priorityType: "" },
        popup: {},
        totalProjects: 0,
        projects: []
    }),
    methods: {
        ShowInformation: function() {
            const projectLabel = this.totalProjects !== 1 ? "Projects" : "Project";
            const { year } = this.year;
            let popupTitle = `${this.totalProjects} ${projectLabel} in ${year}`;
            if (this.totalProjects === 0) {
                popupTitle = `Projects in ${year}`;
            }
            this.popup = {
                show: true,
                title: popupTitle,
                content: "TimelineYearProjectList",
                topography: this.maxTopography + 100,
                projects: this.projects
            };
        },
        ClosePopup: function() { this.popup.show = false; },
        ViewProject: function(project) {
            const route = router.getRoutes().filter(r => r.name === "Project")[0];
            const { Project } = project;
            const formattedProject = ASSETS.CleanURL(Project);
            ASSETS.Projects.View(
                this,
                store,
                project,
                formattedProject,
                Project,
                route
            );
            this.ClosePopup();
        },
        Classes: function() {
            return {
                informationButtonState: this.enabled ? "" : "disabled-fade"
            };
        },

        // Prepare list of projects by year
        SetProjects: function() {
            if (this.timelineData) {
                const projects = this.timelineData.filter(t => t.CoordinateYearIndex === this.index);
                const socialImpactStartYear = PriorityTypes.Projects.PriorityTypes.filter(p => p.Name === "Social Impact")[0].DateRange.Start;
                let totalProjects = 0;
                for (const project of projects) {
                    project.Show = true;
                    const { Start, SocialImpact } = project;
                    const startYear = new Date(Start).getFullYear();
                    if (startYear >= socialImpactStartYear && !SocialImpact) {
                        project.Show = false;
                    }
                    if (project.Show) {
                        totalProjects++;
                    }
                }
                this.totalProjects = totalProjects;
                this.projects = projects;
            }
        },

        ViewingYear: function(year) {
            if (this.selectedYearRange) {
                const { start, end } = this.selectedYearRange;
                let viewingYear = false;
                if (start === end) {
                    viewingYear = start === year;
                } else {
                    viewingYear = start === year || end === year;
                }
                return viewingYear;
            }
            return false;
        }
    },
    beforeMount: function() {
        this.classes.priorityType = `year-priority-type-${this.year.priorityType.name.toLowerCase()}`;
        this.SetProjects();
    },
    emits: [ "project" ]
};
</script>